import MessageRendererInlineSurveyLinks from '../modules/message-renderer-inline-survey-links/src/message-renderer-inline-survey-links';
import ResponseHandlerInlineSurveyLinks from "../modules/message-renderer-inline-survey-links/src/response-handler-inline-survey-links";

export { MessageRendererInlineSurveyLinks, ResponseHandlerInlineSurveyLinks };



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/ref/message-renderer-inline-survey-links.js